import { useState } from "react";

const SearchInput = (props: any) => {
  let placeholder = props.placeholder ?? "";
  let value = props.value ?? "";

  const updateValue = (valueInput: any) => {
    setSearch(valueInput);
    props.onChange(valueInput);
  };

  const handleOnKeyPress = () => {
    props.onSearchKeyPress && props.onSearchKeyPress(search);
  };

  const [search, setSearch] = useState(value);
  return (
    <input
      value={search}
      placeholder={placeholder}
      onChange={(e) => updateValue(e.target.value)}
      className={`form-control Input ${props.className}`}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          handleOnKeyPress();
        }
      }}
    />
  );
};

export default SearchInput;
